import { render, staticRenderFns } from "./ShekelInput.vue?vue&type=template&id=69480938&scoped=true&"
import script from "./ShekelInput.vue?vue&type=script&lang=js&"
export * from "./ShekelInput.vue?vue&type=script&lang=js&"
import style0 from "./ShekelInput.vue?vue&type=style&index=0&id=69480938&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69480938",
  null
  
)

export default component.exports